import React from "react";

import Announcement03 from "@uui/Announcement03";
import ArrowRight from "@uui/ArrowRight";
import Calendar from "@uui/Calendar";
import SvgCheckCircle from "@uui/CheckCircle";
import Copy01 from "@uui/Copy01";
import DotsGrid from "@uui/DotsGrid";
import Download01 from "@uui/Download01";
import Edit02 from "@uui/Edit02";
import File02 from "@uui/File02";
import File03 from "@uui/File03";
import FilterLines from "@uui/FilterLines";
import GraduationHat02 from "@uui/GraduationHat02";
import IntersectSquare from "@uui/IntersectSquare";
import Link01 from "@uui/Link01";
import SvgLogIn01 from "@uui/LogIn01";
import Mail02 from "@uui/Mail02";
import PlayCircle from "@uui/PlayCircle";
import SVGPlus from "@uui/Plus";
import RefreshCcw05 from "@uui/RefreshCcw05";
import Rocket02 from "@uui/Rocket02";
import SearchMd from "@uui/SearchMd";
import SvgSettings01 from "@uui/Settings01";
import Share05 from "@uui/Share05";
import Share06 from "@uui/Share06";
import Star01 from "@uui/Star01";
import Star06 from "@uui/Star06";
import Stars01 from "@uui/Stars01";
import Tag01 from "@uui/Tag01";
import Trash01 from "@uui/Trash01";
import TypeSquare from "@uui/TypeSquare";
import UserCircle from "@uui/UserCircle";
import Users03 from "@uui/Users03";
import VideoRecorder from "@uui/VideoRecorder";
import Zap from "@uui/Zap";

import { Stack, SvgIcon, SvgIconProps } from "@mui/material";

import { TrendDirection } from "@app/analytics/types";

// The logo part of the read logo (the smiling face)
export const Logomark = ({ size = 46 }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 46 46"
      fill="none"
      style={{ display: "block" }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.0714 23C41.0714 32.9806 32.9806 41.0714 23 41.0714C13.0194 41.0714 4.92859 32.9806 4.92859 23C4.92859 13.0194 13.0194 4.92856 23 4.92856C32.9806 4.92856 41.0714 13.0194 41.0714 23ZM23 36.9627C30.7114 36.9627 36.9627 30.7114 36.9627 23C36.9627 15.2886 30.7114 9.0373 23 9.0373C15.2886 9.0373 9.0373 15.2886 9.0373 23C9.0373 30.7114 15.2886 36.9627 23 36.9627Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.45 26.2857C18.4716 28.3403 20.5751 29.7435 22.9999 29.7435C25.4248 29.7435 27.5283 28.3403 28.5499 26.2857L32.0357 28.0504C30.3781 31.3838 26.9564 33.6786 22.9999 33.6786C19.0435 33.6786 15.6218 31.3838 13.9642 28.0504L17.45 26.2857Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.15811 4.53615V12.3214H-1.90735e-05V4.53615C-1.90735e-05 2.03091 2.03088 9.53674e-06 4.53612 9.53674e-06H12.3214V4.15814H4.53612C4.32735 4.15814 4.15811 4.32738 4.15811 4.53615Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.8419 41.4639V33.6786H46V41.4639C46 43.9691 43.9691 46 41.4639 46H33.6786V41.8419H41.4639C41.6727 41.8419 41.8419 41.6726 41.8419 41.4639Z"
        fill="white"
      />
    </svg>
  );
};

export const LogomarkRounded = (
  props: Omit<React.SVGProps<SVGSVGElement>, "dangerouslySetInnerHTML">
) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="28"
        height="28"
        rx="14"
        fill="url(#paint0_linear_855_11386)"
      />
      <g clipPath="url(#clip0_855_11386)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5707 13.989C20.5707 17.6541 17.5995 20.6254 13.9343 20.6254C10.2691 20.6254 7.29792 17.6541 7.29792 13.989C7.29792 10.3238 10.2691 7.35261 13.9343 7.35261C17.5995 7.35261 20.5707 10.3238 20.5707 13.989ZM13.9343 19.0484C16.7285 19.0484 18.9937 16.7832 18.9937 13.989C18.9937 11.1947 16.7285 8.92957 13.9343 8.92957C11.1401 8.92957 8.87488 11.1947 8.87488 13.989C8.87488 16.7832 11.1401 19.0484 13.9343 19.0484Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.85 14.7054C12.1597 15.5582 12.9771 16.1653 13.9343 16.1653C14.8915 16.1653 15.7089 15.5582 16.0186 14.7054L17.5008 15.2437C16.972 16.7 15.5758 17.7423 13.9343 17.7423C12.2927 17.7423 10.8966 16.7 10.3678 15.2437L11.85 14.7054Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2277 20.7568V18.1285H22.8047V20.7568C22.8047 21.918 21.8633 22.8594 20.7021 22.8594H18.0738V21.2824H20.7021C20.9924 21.2824 21.2277 21.0471 21.2277 20.7568Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.77227 7.35261V9.98088H5.19531V7.35261C5.19531 6.19137 6.13668 5.25 7.29792 5.25H9.92619V6.82696H7.29792C7.00761 6.82696 6.77227 7.0623 6.77227 7.35261Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_855_11386"
          x1="7.08861"
          y1="21.7089"
          x2="23.7468"
          y2="6.91139"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4361EE" />
          <stop offset="1" stopColor="#7B61FF" />
        </linearGradient>
        <clipPath id="clip0_855_11386">
          <rect
            width="17.6094"
            height="17.6094"
            fill="white"
            transform="translate(5.19531 5.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// The word "Read"
export const Textmark = (props: SvgIconProps) => {
  return (
    <SvgIcon width="68" height="22" viewBox="0 0 68 22" fill="none" {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="68"
        height="22"
        viewBox="0 0 68 22"
        fill="none"
      >
        <path
          d="M10.3958 21.2745L5.9024 13.4672H3.45913V21.2745H0.257599V1.75635H6.99767C8.49546 1.75635 9.75922 2.01846 10.789 2.54269C11.8374 3.06691 12.6144 3.76901 13.1199 4.64896C13.6441 5.52891 13.9062 6.51184 13.9062 7.59774C13.9062 8.87086 13.5318 10.0316 12.7829 11.0801C12.0527 12.1098 10.92 12.8119 9.38477 13.1864L14.2152 21.2745H10.3958ZM3.45913 10.9116H6.99767C8.1959 10.9116 9.09458 10.612 9.69369 10.0129C10.3115 9.41381 10.6205 8.60875 10.6205 7.59774C10.6205 6.58673 10.3209 5.80039 9.72178 5.23871C9.12266 4.65832 8.21462 4.36812 6.99767 4.36812H3.45913V10.9116Z"
          fill="white"
        />
        <path
          d="M31.6224 13.1583C31.6224 13.7387 31.5849 14.2629 31.51 14.731H19.6868C19.7805 15.9667 20.2392 16.9589 21.0629 17.7078C21.8867 18.4567 22.8977 18.8312 24.096 18.8312C25.8184 18.8312 27.0354 18.1104 27.7468 16.6687H31.2011C30.7331 18.0916 29.8812 19.2618 28.6455 20.1792C27.4286 21.0779 25.912 21.5272 24.096 21.5272C22.6169 21.5272 21.2876 21.1996 20.1081 20.5443C18.9473 19.8703 18.0299 18.9342 17.3559 17.7359C16.7006 16.519 16.373 15.1148 16.373 13.5234C16.373 11.932 16.6913 10.5372 17.3278 9.33892C17.9831 8.12196 18.8911 7.18584 20.0519 6.53056C21.2314 5.87528 22.5795 5.54763 24.096 5.54763C25.5563 5.54763 26.8575 5.86591 27.9996 6.50248C29.1417 7.13904 30.031 8.03771 30.6675 9.1985C31.3041 10.3406 31.6224 11.6605 31.6224 13.1583ZM28.2804 12.1473C28.2617 10.9678 27.8405 10.0223 27.0167 9.31084C26.1929 8.59938 25.1725 8.24366 23.9556 8.24366C22.8509 8.24366 21.9055 8.59938 21.1191 9.31084C20.3328 10.0036 19.8647 10.949 19.7149 12.1473H28.2804Z"
          fill="white"
        />
        <path
          d="M33.1442 13.4672C33.1442 11.9132 33.4624 10.5372 34.099 9.33892C34.7543 8.14069 35.6342 7.21393 36.7389 6.55864C37.8622 5.88464 39.0979 5.54763 40.4459 5.54763C41.6629 5.54763 42.7207 5.79102 43.6194 6.27781C44.5367 6.74587 45.2669 7.33562 45.8099 8.04707V5.80039H49.0395V21.2745H45.8099V18.9716C45.2669 19.7018 44.5274 20.3103 43.5913 20.797C42.6551 21.2838 41.588 21.5272 40.3897 21.5272C39.0604 21.5272 37.8435 21.1902 36.7389 20.5162C35.6342 19.8235 34.7543 18.8686 34.099 17.6517C33.4624 16.416 33.1442 15.0212 33.1442 13.4672ZM45.8099 13.5234C45.8099 12.4562 45.5852 11.5294 45.1359 10.7431C44.7052 9.95676 44.1342 9.35764 43.4228 8.94575C42.7113 8.53386 41.9437 8.32791 41.1199 8.32791C40.2961 8.32791 39.5285 8.53386 38.8171 8.94575C38.1056 9.33892 37.5252 9.92868 37.0759 10.715C36.6453 11.4826 36.4299 12.4 36.4299 13.4672C36.4299 14.5344 36.6453 15.4705 37.0759 16.2756C37.5252 17.0806 38.1056 17.6985 38.8171 18.1291C39.5472 18.541 40.3148 18.7469 41.1199 18.7469C41.9437 18.7469 42.7113 18.541 43.4228 18.1291C44.1342 17.7172 44.7052 17.1181 45.1359 16.3317C45.5852 15.5267 45.8099 14.5906 45.8099 13.5234Z"
          fill="white"
        />
        <path
          d="M51.6157 13.4672C51.6157 11.9132 51.934 10.5372 52.5706 9.33892C53.2258 8.14069 54.1058 7.21393 55.2104 6.55864C56.3338 5.88464 57.5788 5.54763 58.9455 5.54763C59.9566 5.54763 60.9488 5.7723 61.9224 6.22164C62.9147 6.65226 63.701 7.23265 64.2814 7.96282V0.492584H67.511V21.2745H64.2814V18.9435C63.7572 19.6924 63.027 20.3103 62.0909 20.797C61.1735 21.2838 60.1157 21.5272 58.9175 21.5272C57.5694 21.5272 56.3338 21.1902 55.2104 20.5162C54.1058 19.8235 53.2258 18.8686 52.5706 17.6517C51.934 16.416 51.6157 15.0212 51.6157 13.4672ZM64.2814 13.5234C64.2814 12.4562 64.0568 11.5294 63.6074 10.7431C63.1768 9.95676 62.6058 9.35764 61.8943 8.94575C61.1829 8.53386 60.4153 8.32791 59.5915 8.32791C58.7677 8.32791 58.0001 8.53386 57.2886 8.94575C56.5772 9.33892 55.9968 9.92868 55.5474 10.715C55.1168 11.4826 54.9015 12.4 54.9015 13.4672C54.9015 14.5344 55.1168 15.4705 55.5474 16.2756C55.9968 17.0806 56.5772 17.6985 57.2886 18.1291C58.0188 18.541 58.7864 18.7469 59.5915 18.7469C60.4153 18.7469 61.1829 18.541 61.8943 18.1291C62.6058 17.7172 63.1768 17.1181 63.6074 16.3317C64.0568 15.5267 64.2814 14.5906 64.2814 13.5234Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

// The logo (smiling face) with the text Read
export const Wordmark = ({
  width = 100,
  height = 80,
  sx,
}: {
  width?: number;
  height?: number;
  currentColor?: React.CSSProperties["color"];
  sx?: any;
}) => {
  return (
    <SvgIcon
      sx={{ width: width, height: height, ...sx }}
      viewBox="0 0 1285 422"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M650.247 322.062L599.562 233.996H572.002V322.062H535.889V101.898H611.916C628.811 101.898 643.066 104.855 654.682 110.768C666.508 116.682 675.273 124.601 680.975 134.527C686.888 144.453 689.844 155.54 689.844 167.789C689.844 182.15 685.621 195.243 677.173 207.07C668.937 218.685 656.16 226.605 638.843 230.829L693.329 322.062H650.247ZM572.002 205.169H611.916C625.432 205.169 635.569 201.79 642.327 195.032C649.296 188.274 652.781 179.193 652.781 167.789C652.781 156.385 649.402 147.515 642.644 141.179C635.886 134.633 625.643 131.359 611.916 131.359H572.002V205.169Z" />
      <path d="M880.178 230.512C880.178 237.059 879.756 242.972 878.911 248.252H745.546C746.602 262.19 751.776 273.383 761.068 281.83C770.361 290.278 781.765 294.502 795.281 294.502C814.71 294.502 828.437 286.371 836.462 270.109H875.426C870.147 286.16 860.538 299.359 846.599 309.707C832.872 319.844 815.766 324.913 795.281 324.913C778.597 324.913 763.603 321.217 750.298 313.825C737.204 306.223 726.856 295.663 719.253 282.147C711.862 268.42 708.166 252.581 708.166 234.63C708.166 216.679 711.756 200.945 718.936 187.429C726.328 173.702 736.571 163.143 749.664 155.751C762.969 148.36 778.175 144.664 795.281 144.664C811.753 144.664 826.431 148.254 839.313 155.435C852.196 162.615 862.227 172.752 869.408 185.846C876.588 198.728 880.178 213.617 880.178 230.512ZM842.481 219.108C842.27 205.803 837.518 195.138 828.226 187.113C818.934 179.088 807.424 175.075 793.697 175.075C781.237 175.075 770.572 179.088 761.702 187.113C752.832 194.927 747.552 205.592 745.863 219.108H842.481Z" />
      <path d="M903.679 233.996C903.679 216.468 907.27 200.945 914.45 187.429C921.841 173.913 931.767 163.46 944.227 156.068C956.899 148.465 970.837 144.664 986.043 144.664C999.77 144.664 1011.7 147.409 1021.84 152.9C1032.19 158.18 1040.42 164.832 1046.55 172.858V147.515H1082.98V322.062H1046.55V296.085C1040.42 304.322 1032.08 311.185 1021.52 316.676C1010.96 322.167 998.925 324.913 985.409 324.913C970.415 324.913 956.687 321.111 944.227 313.508C931.767 305.695 921.841 294.924 914.45 281.197C907.27 267.258 903.679 251.525 903.679 233.996ZM1046.55 234.63C1046.55 222.592 1044.01 212.138 1038.95 203.269C1034.09 194.399 1027.65 187.641 1019.62 182.995C1011.6 178.348 1002.94 176.025 993.645 176.025C984.353 176.025 975.694 178.348 967.669 182.995C959.644 187.429 953.097 194.082 948.029 202.952C943.171 211.61 940.743 221.959 940.743 233.996C940.743 246.034 943.171 256.593 948.029 265.674C953.097 274.756 959.644 281.725 967.669 286.582C975.906 291.228 984.564 293.551 993.645 293.551C1002.94 293.551 1011.6 291.228 1019.62 286.582C1027.65 281.936 1034.09 275.178 1038.95 266.308C1044.01 257.227 1046.55 246.668 1046.55 234.63Z" />
      <path d="M1105.7 233.996C1105.7 216.468 1109.29 200.945 1116.47 187.429C1123.86 173.913 1133.79 163.46 1146.25 156.068C1158.92 148.465 1172.97 144.664 1188.38 144.664C1199.79 144.664 1210.98 147.198 1221.96 152.267C1233.15 157.124 1242.02 163.671 1248.57 171.907V87.6433H1285V322.062H1248.57V295.769C1242.66 304.216 1234.42 311.185 1223.86 316.676C1213.51 322.167 1201.58 324.913 1188.06 324.913C1172.86 324.913 1158.92 321.111 1146.25 313.508C1133.79 305.695 1123.86 294.924 1116.47 281.197C1109.29 267.258 1105.7 251.525 1105.7 233.996ZM1248.57 234.63C1248.57 222.592 1246.04 212.138 1240.97 203.269C1236.11 194.399 1229.67 187.641 1221.64 182.995C1213.62 178.348 1204.96 176.025 1195.67 176.025C1186.38 176.025 1177.72 178.348 1169.69 182.995C1161.67 187.429 1155.12 194.082 1150.05 202.952C1145.19 211.61 1142.77 221.959 1142.77 233.996C1142.77 246.034 1145.19 256.593 1150.05 265.674C1155.12 274.756 1161.67 281.725 1169.69 286.582C1177.93 291.228 1186.59 293.551 1195.67 293.551C1204.96 293.551 1213.62 291.228 1221.64 286.582C1229.67 281.936 1236.11 275.178 1240.97 266.308C1246.04 257.227 1248.57 246.668 1248.57 234.63Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M368.463 209.425C368.463 297.259 297.259 368.463 209.425 368.463C121.591 368.463 50.3881 297.259 50.3881 209.425C50.3881 121.591 121.591 50.3881 209.425 50.3881C297.259 50.3881 368.463 121.591 368.463 209.425ZM209.425 330.672C276.388 330.672 330.672 276.388 330.672 209.425C330.672 142.463 276.388 88.1791 209.425 88.1791C142.463 88.1791 88.1791 142.463 88.1791 209.425C88.1791 276.388 142.463 330.672 209.425 330.672Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.477 226.595C166.898 247.031 186.487 261.581 209.425 261.581C232.364 261.581 251.953 247.031 259.374 226.595L294.895 239.494C282.221 274.394 248.764 299.372 209.425 299.372C170.086 299.372 136.629 274.394 123.956 239.494L159.477 226.595Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M384.209 371.612V308.627H422V371.612C422 399.441 399.44 422 371.612 422H308.627V384.209H371.612C378.569 384.209 384.209 378.569 384.209 371.612Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.791 50.3881V113.373H0V50.3881C0 22.5595 22.5595 0 50.3881 0H113.373V37.791H50.3881C43.4309 37.791 37.791 43.4309 37.791 50.3881Z"
      />
    </SvgIcon>
  );
};

export const BotChatBubble = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M2 13.01V7C2 4.79086 3.79086 3 6 3H18C20.2091 3 22 4.79086 22 7V13C22 15.2091 20.2091 17 18 17H11.6213C11.2235 17 10.842 17.158 10.5607 17.4393L7.02426 20.9757C6.64629 21.3537 6 21.086 6 20.5515V17.01C6 17.0045 5.99553 17 5.99003 17C3.7864 17 2 15.2136 2 13.01Z"
        fill="white"
        fillOpacity="62%"
        stroke="white"
        strokeWidth="2px"
      />
    </SvgIcon>
  );
};

export const BotProgressIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 10 10" {...props}>
      <circle cx="5" cy="5" r="5" fill="white" stroke="none" />
    </SvgIcon>
  );
};

export const BotProgressIconOutline = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 8 8" {...props}>
      <circle cx="4" cy="4" r="3.5" stroke="white" fill="none" />
    </SvgIcon>
  );
};

interface TrendProps extends SvgIconProps {
  direction: TrendDirection | number;
}

export const TrendArrowIcon = (props: TrendProps) => {
  const direction = props.direction;
  let rotation = 0;
  if (
    direction === "positive" ||
    (typeof direction == "number" && direction >= 1)
  ) {
    rotation = -90;
  } else if (
    direction === "negative" ||
    (typeof direction === "number" && direction <= -1)
  ) {
    rotation = 90;
  }

  return (
    <ArrowRight
      sx={{
        transition: "transform 0.2s ease",
        transform: `rotate(${rotation}deg)`,
        ...props.sx,
      }}
    />
  );
};

export const ReadAverageIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 21 12" {...props}>
      <path d="M0.0195312 6H20.0195" stroke="#3D39A3" strokeWidth="3" />
      <circle
        cx="10"
        cy="6"
        r="4.5"
        fill="white"
        stroke="#3D39A3"
        strokeWidth="3"
      />
    </SvgIcon>
  );
};

export const SignInCircle = () => (
  <Stack sx={{ borderRadius: "50%", bgcolor: "shades.orange.50", p: "2px" }}>
    <SvgLogIn01
      sx={{ width: "12px", height: "12px", color: "shades.orange.500" }}
    />
  </Stack>
);

export const SignedInCircle = () => (
  <Stack sx={{ borderRadius: "50%", bgcolor: "shades.meadow.50", p: "2px" }}>
    <SvgCheckCircle
      sx={{ width: "12px", height: "12px", color: "shades.meadow.500" }}
    />
  </Stack>
);

export const PlayFilled = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M8 6.82V17.18C8 17.97 8.87 18.45 9.54 18.02L17.68 12.84C18.3 12.45 18.3 11.55 17.68 11.15L9.54 5.98C8.87 5.55 8 6.03 8 6.82Z"
        fill={props.fill ?? "inherit"}
      />
    </SvgIcon>
  );
};

export const PauseIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M8 19C9.1 19 10 18.1 10 17V7C10 5.9 9.1 5 8 5C6.9 5 6 5.9 6 7V17C6 18.1 6.9 19 8 19ZM14 7V17C14 18.1 14.9 19 16 19C17.1 19 18 18.1 18 17V7C18 5.9 17.1 5 16 5C14.9 5 14 5.9 14 7Z"
        fill={props.fill ?? "inherit"}
      />
    </SvgIcon>
  );
};

export const SkipForward10Icon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.95542 13.5509C3.20384 15.1789 3.92944 16.6967 5.04047 17.9123C6.1515 19.1279 7.59804 19.9867 9.19719 20.3802C10.7963 20.7737 12.4762 20.6842 14.0245 20.1229C14.4139 19.9818 14.6152 19.5516 14.474 19.1622C14.3328 18.7728 13.9027 18.5716 13.5133 18.7127C12.2439 19.1729 10.8667 19.2463 9.55559 18.9237C8.24453 18.6011 7.05857 17.8969 6.14769 16.9003C5.23681 15.9037 4.64192 14.6593 4.43825 13.3246C4.23458 11.9899 4.43127 10.6247 5.00345 9.4018C5.57564 8.17887 6.49762 7.15307 7.6528 6.45412C8.80798 5.75518 10.1445 5.41448 11.4933 5.47511C12.8421 5.53575 14.1426 5.99499 15.2305 6.79476C15.9092 7.29381 16.4862 7.91147 16.9359 8.61381L15.8488 8.35444C15.4459 8.25831 15.0413 8.507 14.9452 8.90991C14.8491 9.31281 15.0978 9.71736 15.5007 9.81349L17.9286 10.3928C18.406 10.5067 18.8956 10.2572 19.084 9.80395L19.9854 7.63588C20.1444 7.2534 19.9632 6.81444 19.5808 6.65543C19.1983 6.49641 18.7593 6.67757 18.6003 7.06004L18.2543 7.89233C17.6981 6.9995 16.9749 6.21555 16.119 5.58624C14.7921 4.61073 13.2058 4.05058 11.5607 3.97663C9.91547 3.90267 8.2853 4.31823 6.87629 5.17075C5.46729 6.02328 4.34272 7.27447 3.64481 8.76612C2.9469 10.2578 2.70699 11.9229 2.95542 13.5509Z"
      fill="white"
    />
    <path
      d="M9.30682 10.0795V15.8977H8.42614V10.9602H8.39205L7 11.8693V11.0284L8.4517 10.0795H9.30682Z"
      fill="white"
    />
    <path
      d="M12.9062 15.9943C12.4574 15.9924 12.0739 15.8741 11.7557 15.6392C11.4375 15.4044 11.1941 15.0625 11.0256 14.6136C10.857 14.1648 10.7727 13.6241 10.7727 12.9915C10.7727 12.3608 10.857 11.822 11.0256 11.375C11.196 10.928 11.4403 10.5871 11.7585 10.3523C12.0786 10.1174 12.4612 10 12.9062 10C13.3513 10 13.733 10.1184 14.0511 10.3551C14.3693 10.59 14.6127 10.9309 14.7813 11.3778C14.9517 11.8229 15.0369 12.3608 15.0369 12.9915C15.0369 13.6259 14.9527 14.1676 14.7841 14.6165C14.6155 15.0634 14.3722 15.4053 14.054 15.642C13.7358 15.8769 13.3532 15.9943 12.9062 15.9943ZM12.9062 15.2358C13.3002 15.2358 13.608 15.0436 13.8295 14.6591C14.053 14.2746 14.1648 13.7188 14.1648 12.9915C14.1648 12.5085 14.1136 12.1004 14.0114 11.767C13.911 11.4318 13.7661 11.178 13.5767 11.0057C13.3892 10.8314 13.1657 10.7443 12.9062 10.7443C12.5142 10.7443 12.2064 10.9375 11.983 11.3239C11.7595 11.7102 11.6468 12.2661 11.6449 12.9915C11.6449 13.4763 11.6951 13.8864 11.7955 14.2216C11.8977 14.5549 12.0426 14.8078 12.2301 14.9801C12.4176 15.1506 12.643 15.2358 12.9062 15.2358Z"
      fill="white"
    />
  </SvgIcon>
);

export const SkipBackward10Icon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0446 13.5509C20.7962 15.1789 20.0706 16.6967 18.9596 17.9123C17.8485 19.1279 16.402 19.9867 14.8028 20.3802C13.2037 20.7737 11.5238 20.6842 9.97553 20.1229C9.58611 19.9818 9.38487 19.5516 9.52604 19.1622C9.6672 18.7728 10.0973 18.5716 10.4867 18.7127C11.7561 19.1729 13.1334 19.2463 14.4444 18.9237C15.7555 18.6011 16.9415 17.8969 17.8523 16.9003C18.7632 15.9037 19.3581 14.6593 19.5618 13.3246C19.7655 11.9899 19.5688 10.6247 18.9966 9.4018C18.4244 8.17887 17.5024 7.15307 16.3472 6.45412C15.1921 5.75518 13.8556 5.41448 12.5067 5.47511C11.1579 5.53575 9.85739 5.99499 8.76958 6.79476C8.09079 7.29381 7.51386 7.91147 7.06417 8.61381L8.15126 8.35444C8.55417 8.25831 8.95871 8.507 9.05484 8.90991C9.15097 9.31281 8.90228 9.71736 8.49937 9.81349L6.07148 10.3928C5.59401 10.5067 5.10446 10.2572 4.91602 9.80395L4.01466 7.63588C3.85565 7.2534 4.0368 6.81444 4.41928 6.65543C4.80176 6.49641 5.24072 6.67757 5.39973 7.06004L5.74575 7.89233C6.30192 6.9995 7.02509 6.21555 7.88106 5.58624C9.20789 4.61073 10.7942 4.05058 12.4394 3.97663C14.0846 3.90267 15.7147 4.31823 17.1237 5.17075C18.5327 6.02328 19.6573 7.27447 20.3552 8.76612C21.0531 10.2578 21.293 11.9229 21.0446 13.5509Z"
      fill="white"
    />
    <path
      d="M11.3068 10.0795V15.8977H10.4261V10.9602H10.392L9 11.8693V11.0284L10.4517 10.0795H11.3068Z"
      fill="white"
    />
    <path
      d="M14.9062 15.9943C14.4574 15.9924 14.0739 15.8741 13.7557 15.6392C13.4375 15.4044 13.1941 15.0625 13.0256 14.6136C12.857 14.1648 12.7727 13.6241 12.7727 12.9915C12.7727 12.3608 12.857 11.822 13.0256 11.375C13.196 10.928 13.4403 10.5871 13.7585 10.3523C14.0786 10.1174 14.4612 10 14.9062 10C15.3513 10 15.733 10.1184 16.0511 10.3551C16.3693 10.59 16.6127 10.9309 16.7813 11.3778C16.9517 11.8229 17.0369 12.3608 17.0369 12.9915C17.0369 13.6259 16.9527 14.1676 16.7841 14.6165C16.6155 15.0634 16.3722 15.4053 16.054 15.642C15.7358 15.8769 15.3532 15.9943 14.9062 15.9943ZM14.9062 15.2358C15.3002 15.2358 15.608 15.0436 15.8295 14.6591C16.053 14.2746 16.1648 13.7188 16.1648 12.9915C16.1648 12.5085 16.1136 12.1004 16.0114 11.767C15.911 11.4318 15.7661 11.178 15.5767 11.0057C15.3892 10.8314 15.1657 10.7443 14.9062 10.7443C14.5142 10.7443 14.2064 10.9375 13.983 11.3239C13.7595 11.7102 13.6468 12.2661 13.6449 12.9915C13.6449 13.4763 13.6951 13.8864 13.7955 14.2216C13.8977 14.5549 14.0426 14.8078 14.2301 14.9801C14.4176 15.1506 14.643 15.2358 14.9062 15.2358Z"
      fill="white"
    />
  </SvgIcon>
);

/** Semantic icon aliases */

// plans / billing
export const EnterpriseIcon = Rocket02;
export const EnterpriseEduIcon = GraduationHat02;
export const ProIcon = Star01;
export const ProEduIcon = GraduationHat02;
export const ZoomTrialIcon = Star01;
export const FreePlanIcon = UserCircle;
export const UpgradeIcon = Rocket02;

// features / products
export const CalendarIcon = Calendar;
export const CoachingIcon = Announcement03;
export const IntegrationIcon = IntersectSquare;
export const ForYouIcon = Stars01;
export const RecommendationsIcon = Zap;
export const ReportsIcon = File02;
export const RecordingAndPlaybackIcon = PlayCircle;
export const EmailIcon = Mail02;
export const CustomVocabularyIcon = TypeSquare;
export const ReportingIcon = File03;
export const MeetingAssistantIcon = VideoRecorder;
export const AccountIcon = UserCircle;

// actions
export const CopyIcon = Copy01;
export const DownloadIcon = Download01;
export const EditIcon = Edit02;
export const FilterIcon = FilterLines;
export const SearchIcon = SearchMd;
export const ShareIcon = Share06;
export const SyncIcon = RefreshCcw05;
export const TrashIcon = Trash01;
export const PlusIcon = SVGPlus;

// misc
export const AIIcon = Star06;
export const ExternalLinkIcon = Share05;
export const LinkIcon = Link01;
export const TagIcon = Tag01;
export const UsersIcon = Users03;
export const SettingsIcon = SvgSettings01;
export const GridIcon = DotsGrid;
